export var MuiDivider = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return {
        borderColor: theme.palette.grey[200]
      };
    }
  }
};
//# sourceMappingURL=MuiDivider.js.map